module.exports = __webpack_public_path__ + "img/orientacion.9c69c8d1.jpg";